export const quotes = [
  {
    quote:
      "Surround yourself with people who challenge you, teach you, and push you to be your best.",
    quotee: "Bill Gates"
  },
  {
    quote: "That is what you realize every day for the people you assist",
    quotee: "More Public Support, Less Headache "
  },
  {
    quote: "Whatever you are, be a good one.",
    quotee: "Abraham Lincoln"
  },
  {
    quote:
      "Life moves pretty fast. If you don’t stop and look around once in a while, you could miss it.",
    quotee: "Ferris Bueller"
  },
  {
    quote: "Be kind whenever possible. It is always possible.",
    quotee: "Dalai Lama"
  },
  {
    quote: "Words are … our most inexhaustible source of magic.",
    quotee: "Albus Dumbledore"
  },
  {
    quote: "If only. Those must be the two saddest words in the world.",
    quotee: "Mercedes Lackey"
  },
  {
    quote:
      "Never regret. If it's good, it's wonderful. If it's bad, it's experience.",
    quotee: "Victoria Holt"
  },
  {
    quote:
      "I have no regrets. I wouldn't have lived my life the way I did if I was going to worry about what people were going to say.",
    quotee: "Ingrid Bergman"
  },
  {
    quote:
      "Your vision will become clear only when you can look into your own heart. Who looks outside, dreams; who looks inside, awakens.",
    quotee: "Carl Jung"
  },
  {
    quote:
      "The most basic of all human needs is the need to understand and be understood. The best way to understand people is to listen to them.",
    quotee: "Ralph Nichols"
  },
  {
    quote:
      "The value of compassion cannot be over-emphasized. Anyone can criticize. It takes a true believer to be compassionate. No greater burden can be borne by an individual than to know no one cares or understands.",
    quotee: "Arthur H. Stainback"
  },
  {
    quote: "Wherever your heart is, there you will find your treasure.",
    quotee: "Paulo Coelho"
  },
  {
    quote:
      "It's the possibility of having a dream come true that makes life interesting.",
    quotee: "Paulo Coelho"
  },
  {
    quote:
      "Brick walls are there for a reason. They let us prove how badly we want things.",
    quotee: "Randy Pausch"
  },
  {
    quote: "Failing to prepare is preparing to fail",
    quotee: "Anonymous"
  },
  {
    quote:
      "I'm a great believer in luck and I find the harder I work, the more I have of it. ",
    quotee: "Thomas Jefferson"
  },
  {
    quote: "No winter lasts forever; no spring skips it's turn.",
    quotee: "Hal Borland"
  },
  {
    quote:
      "Aerodynamically the bumblebee shouldn't be able to fly, but the bumblebee doesn't know that so it goes on flying anyway.",
    quotee: "Mary Kay Ash"
  },
  {
    quote:
      "There will come a time when you believe everything is finished. That will be the beginning.",
    quotee: "Louis L'Amour"
  },
  {
    quote:
      "We are all faced with a series of great opportunities brilliantly disguised as impossible situations.",
    quotee: "Charles R. Swindoll"
  }
];
